import { ITask } from '../../../../types/tasks.types'
import ZeroTaskSandbox from './ZeroTaskSandbox'
import FirstTaskSandbox from './FirstTypeSandbox'
import SecondTypeSandbox from './SecondTypeSandbox'
import ThirdTaskSandbox from './ThirdTypeSandbox'
import FourthTaskSandbox from './FourthTypeSandbox'
import SixthTypeSandbox from './SixthTypeSandbox'
import FifthTaskSandbox from './FifthTypeSandbox'
import SeventhTypeSandbox from './SeventhTypeSandbox'
import EightTaskSandbox from './EightTypeTask'
import NineTypeTask from './NineTypeTask'
import TenthTaskSandbox from './TenthTypeSandbox'
import EleventhTypeSandbox from './EleventhTypeSandbox'
import TwelfthTypeSandbox from './TwelfthTypeSandbox'
import ThirteenthTaskSandbox from './ThirteenthTypeSandbox'
import FourteenthTypeTask from './FourteenthTypeTask'
import FifteenthTypeTask from './FifteenthTypeSandbox'
import SixteenthTaskSandbox from './SixteenthTypeTask'

interface IProps {
  taskType: ITask['type']
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const TaskSandbox = (props: IProps) => {
  switch (props.taskType) {
    case 0:
      return <ZeroTaskSandbox onDraftTaskChange={props.onDraftTaskChange as any} />
    case 1:
      return <FirstTaskSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 2:
      return <SecondTypeSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 3:
      return <ThirdTaskSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 4:
      return <FourthTaskSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 5:
      return <FifthTaskSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 6:
      return <SixthTypeSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 7:
      return <SeventhTypeSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 8:
      return <EightTaskSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 9:
      return <NineTypeTask onDraftTaskChange={props.onDraftTaskChange} />
    case 10:
      return <TenthTaskSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 11:
      return <EleventhTypeSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 12:
      return <TwelfthTypeSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 13:
      return <ThirteenthTaskSandbox onDraftTaskChange={props.onDraftTaskChange} />
    case 14:
      return <FourteenthTypeTask onDraftTaskChange={props.onDraftTaskChange} />
    case 15:
      return <FifteenthTypeTask onDraftTaskChange={props.onDraftTaskChange} />
    case 16:
      return <SixteenthTaskSandbox onDraftTaskChange={props.onDraftTaskChange} />
    default:
      return null
  }
}

export default TaskSandbox
